
import Header from "../Global/header";
import ContactForm from "./contact";
import Footer from "../Global/footer";

export default function ContactPage() {
  return (
    <main>
      <Header />
      <ContactForm />
      <Footer />
    </main>
  );
}